import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExportService {
  downloadCsv(filename: string, rows: Array<Record<string, unknown>>): void {
    const normalizedRows =
      rows.length > 0 ? rows : [{ 'No data': 'No data' } satisfies Record<string, unknown>];
    const headers = Object.keys(
      normalizedRows.reduce<Record<string, unknown>>(
        (acc, row) => ({ ...acc, ...row }),
        {}
      )
    );

    const csvLines = [
      headers.map((header) => this.escapeCsvValue(header)).join(','),
      ...normalizedRows.map((row) =>
        headers.map((header) => this.escapeCsvValue(row[header])).join(',')
      )
    ];

    const csv = csvLines.join('\r\n');
    this.downloadBlob(`${filename}.csv`, csv, 'text/csv;charset=utf-8;');
  }

  printPage(): void {
    window.print();
  }

  downloadJson(filename: string, data: unknown): void {
    const json = JSON.stringify(data, null, 2);
    this.downloadBlob(`${filename}.json`, json, 'application/json;charset=utf-8;');
  }

  private escapeCsvValue(value: unknown): string {
    const text = value == null ? '' : String(value);
    const escaped = text.replace(/"/g, '""');
    return /[",\r\n]/.test(escaped) ? `"${escaped}"` : escaped;
  }

  private downloadBlob(filename: string, content: string, type: string): void {
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  }
}
